export default "__VITE_ASSET__W7vmk9ht__"